// Mirror of backend/app/profanity.py — keep these two in sync.
// Cheap pre-filter so obvious explicit prompts get instant feedback without
// a round-trip to the server. The server still enforces the same list.
const PATTERNS = [
  "porn(?:o|ography)?",
  "nsfw",
  "erotic[a]?",
  "hentai",
  "xxx",
  "sex(?:ual)?",
  "nude",
  "naked",
  "orgasm",
  "orgy",
  "orgies",
  "threesome",
  "foursome",
  "gangbang",
  "bukkake",
  "fuck(?:ing|ed|er|s)?",
  "cum",
  "jizz",
  "jerk(?:ing)?[- ]?off",
  "masturbat\\w+",
  "fap(?:ping)?",
  "blow[- ]?job",
  "hand[- ]?job",
  "rim[- ]?job",
  "deepthroat",
  "creampie",
  "dick",
  "cock",
  "penis",
  "vagina",
  "pussy",
  "cunt",
  "tits?",
  "boobs?",
  "nipples?",
  "clit(?:oris)?",
  "bdsm",
  "bondage",
  "fetish",
];

const RX = new RegExp(`\\b(?:${PATTERNS.join("|")})\\b`, "i");

/** Returns the first matched banned word, or null if the text is clean. */
export function obviousExplicit(text: string): string | null {
  if (!text) return null;
  const m = text.match(RX);
  return m ? m[0] : null;
}
